import { Axios } from "../utils/axios";
///resourcesAdmin/resourcesAdmin/{{resourceId}}
//字典查询
function Login(params) {
  return new Promise((resolve, reject) => {
    Axios.post("/system/auth/loginNew", params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//字典查询
function getResourceType(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/system/dict/data/list", { params }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//学校查询
function getSchools(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/trainAdmin/list", { params }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//学生查询https://pre.airoteach.cn/admin-api/education-member-admin/memberWechatAdmin/queryMemberWechatList?pageNum=10&pageSize=10&trainId=1&name=
function getStudents(params) {
  return new Promise((resolve, reject) => {
    Axios.get(
      "/education-member-admin/memberWechatAdmin/queryMemberWechatList",
      { params }
    ).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//课程查询
function getCourses(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/courseAdmin/course/list", { params }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//考试查询
function getExams(params) {
  return new Promise((resolve, reject) => {
    Axios.get(`/trainAdmin/examinationAdmin/list?${params}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//未开始考试查询
function getExamsValid(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/examinationAdmin/queryNotStartedExaminationList", {
      params
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//查看试卷详情
function getQuestionPaperDetail(Id) {
  return new Promise((resolve, reject) => {
    Axios.get(`/trainAdmin/questionPaperInfo/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查看资源详情
function getResourceDetail(Id) {
  return new Promise((resolve, reject) => {
    Axios.get(`/resourcesAdmin/resourcesAdmin/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查看学校详情
function getSchoolDetail(Id) {
  return new Promise((resolve, reject) => {
    Axios.get(`/trainAdmin/trainAdmin/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//删除资源详情
function deleteResourceDetail(Id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/resourcesAdmin/resourcesAdmin/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//删除考试详情
function deleteCourseDetail(Id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/courseAdmin/course/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//删除考试详情
function deleteExamination(Id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/trainAdmin/examinationAdmin/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
function getExamination(Id) {
  return new Promise((resolve, reject) => {
    Axios.get(`/trainAdmin/examinationAdmin/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//删除学校详情
function deleteSchool(Id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/trainAdmin/trainAdmin/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

//学情导出
function statistics2Excel(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/statistics/export?trainId=1", { params }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查询所有试卷
function allQuestionPaperInfo(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/trainAdmin/questionPaperInfo/all/list", { params }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查询课程一级分类分类列表
function queryOneLevel(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/contentAdmin/courseCategoryAdmin/queryOneLevel", {
      params
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查询课程一级分类分类列表
function queryTowLevel(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/contentAdmin/courseCategoryAdmin/queryTowLevel", {
      params
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查询章节
function getCourseChapter(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/courseAdmin/courseChapter/list", { params }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查询课程详情
function getCourseDetail(Id) {
  return new Promise((resolve, reject) => {
    Axios.get(`/courseAdmin/course/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查询章节详情/courseAdmin/courseChapter/{{chapterId}}
function getCourseChapterDetail(Id) {
  return new Promise((resolve, reject) => {
    Axios.get(`/courseAdmin/courseChapter/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查询课时
function getCourseChapterClass(params) {
  return new Promise((resolve, reject) => {
    Axios.get("/courseAdmin/courseChapterClass/list", { params }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//查询课时详情
function getCourseChapterClassDetail(Id) {
  return new Promise((resolve, reject) => {
    Axios.get(`/courseAdmin/courseChapterClass/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//删除课时
function deleteCourseChapterClass(Id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/courseAdmin/courseChapterClass//${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
//删除章节/courseAdmin/courseChapter/{{chapterId}}
function deleteCourseChapter(Id) {
  return new Promise((resolve, reject) => {
    Axios.delete(`/courseAdmin/courseChapter/${Id}`).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}

function getCourseExam(id) {
  return new Promise((resolve, reject) => {
    Axios.get(`/trainAdmin/courseQuestion/queryInfo`, {
      params: { courseId: id }
    }).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
function addCourseExam(params) {
  return new Promise((resolve, reject) => {
    Axios.post(`/trainAdmin/courseQuestion/saveTest`, params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
function updateAnswer(params) {
  return new Promise((resolve, reject) => {
    Axios.post(`/trainAdmin/questionMemberInfo/updateAnswer`, params).then(
      res => {
        resolve(res);
      },
      err => {
        reject(err);
      }
    );
  });
}
export {
  deleteCourseDetail,
  getSchoolDetail,
  getResourceType,
  getResourceDetail,
  getSchools,
  getStudents,
  getCourses,
  getExams,
  statistics2Excel,
  deleteResourceDetail,
  deleteExamination,
  Login,
  allQuestionPaperInfo,
  deleteSchool,
  queryOneLevel,
  queryTowLevel,
  getCourseChapter,
  deleteCourseChapter,
  getCourseChapterDetail,
  getCourseChapterClass,
  getCourseChapterClassDetail,
  deleteCourseChapterClass,
  getCourseDetail,
  getQuestionPaperDetail,
  getCourseExam,
  addCourseExam,
  getExamination,
  updateAnswer,
  getExamsValid
};



// WEBPACK FOOTER //
// ./src/api/system.js